module.exports = __webpack_public_path__ + "7941e73b8afe845133e50bc1c6f5ab36.MP3";